<mat-card class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h3>Sofort Statements import</h3>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="list-item" fxLayout="row" *ngFor="let col of importCols">
      <label fxFlex="35" class="secondary">{{ col.header }}</label>
      <label fxFlex="65" *ngIf="import">{{ col.cell(import) }}</label>
    </div>
  </mat-card-content>
</mat-card>
<div *ngIf="import">
  <mat-card class="content-card" *ngIf="import.importErrors.length > 0">
    <mat-card-header>
      <mat-card-title>
        <h3>Import errors</h3>
      </mat-card-title>
    </mat-card-header>
      <mat-card-content>
        <app-mat-table-generator #importErrorsTable 
          tableName="importErrorsTable" 
          [columns]="importErrorsCols" 
          [dataSource]="importErrorsDataSource"
          [multiselectEnabled]="false">
        </app-mat-table-generator>
      </mat-card-content>
  </mat-card>
  <mat-card class="content-card" *ngIf="import.sofortStatements.length > 0">
    <mat-card-header>
        <mat-card-title>
          <h3>Import data</h3>
        </mat-card-title>
      </mat-card-header>
    <app-mat-table-generator #importDataTable  
      tableName="importDataTable" 
      [columns]="importDataCols"
      [dataSource]="importDataDataSource" 
      [multiselectEnabled]="false" 
      [rowClassCallback]="getRowClass">
    </app-mat-table-generator>
  </mat-card>
</div>
